require('../proposals/reflect-metadata');
var parent = require('./0');

module.exports = parent;



// WEBPACK FOOTER //
// /Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/core-js/stage/pre.js